import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { DemoBanner } from '../components/DemoBanner';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-376">
      <Header data-id="element-377" />
      <main data-id="element-378">
        <Hero data-id="element-379" />
        <About data-id="element-380" />
        <Services data-id="element-381" />
        <FAQ data-id="element-382" />
        <WhyChooseUs data-id="element-383" />
        <Contact data-id="element-384" />
      </main>
      <Footer data-id="element-385" />
      <DemoBanner data-id="element-386" />
    </div>;
}